const filterPhoneNumber = (value: string) => value.replace(/\s-+/g, '');

export default filterPhoneNumber;
